export const OPEN_EXPORT_SHIPMENTS_MODAL = 'OPEN_EXPORT_SHIPMENTS_MODAL';
export const openExportShipmentsModal = (buildApiFilters) => ({
  type: OPEN_EXPORT_SHIPMENTS_MODAL,
  buildApiFilters,
});

export const EXPORT_SHIPMENTS_REQUEST = 'EXPORT_SHIPMENTS_REQUEST';
export const exportShipmentsRequest = (viewRecordsOrSelectedRecords, primaryRecordsOrLineItems, intl, isOnAdvancedSearch, filters) => ({
  type: EXPORT_SHIPMENTS_REQUEST,
  viewRecordsOrSelectedRecords,
  primaryRecordsOrLineItems,
  intl,
  isOnAdvancedSearch,
  filters,
});

export const EXPORT_SHIPMENTS_SUCCESS = 'EXPORT_SHIPMENTS_SUCCESS';
export const exportShipmentsSuccess = (jobId, initiatedByUserId) => ({
  type: EXPORT_SHIPMENTS_SUCCESS,
  jobId,
  initiatedByUserId,
});

export const EXPORT_SHIPMENTS_COMPLETE = 'EXPORT_SHIPMENTS_COMPLETE';
export const exportShipmentsComplete = (messageGuid, data) => ({
  type: EXPORT_SHIPMENTS_COMPLETE,
  messageGuid,
  data,
});

export const EXPORT_SHIPMENTS_CLEANUP = 'EXPORT_SHIPMENTS_CLEANUP';
export const exportShipmentsCleanup = (jobId) => ({
  type: EXPORT_SHIPMENTS_CLEANUP,
  jobId,
});

export const OPEN_EXPORT_BATCH_SHIPMENTS_MODAL = 'OPEN_EXPORT_BATCH_SHIPMENTS_MODAL';
export const openExportBatchShipmentsModal = () => ({
  type: OPEN_EXPORT_BATCH_SHIPMENTS_MODAL,
});

export const EXPORT_BATCH_SHIPMENTS_REQUEST = 'EXPORT_BATCH_SHIPMENTS_REQUEST';
export const exportBatchShipmentsRequest = (viewRecordsOrSelectedRecords, primaryRecordsOrLineItems, intl) => ({
  type: EXPORT_BATCH_SHIPMENTS_REQUEST,
  viewRecordsOrSelectedRecords,
  primaryRecordsOrLineItems,
  intl,
});

export const CUSTOM_EXPORT_SHIPMENTS_REQUEST = 'CUSTOM_EXPORT_SHIPMENTS_REQUEST';
export const customExportShipmentsRequest = ({
  viewRecordsOrSelectedRecords,
  extractId,
  selectedFulfillmentIds,
  searchTerm,
  filters,
  isOnAdvancedSearch,
}) => ({
  type: CUSTOM_EXPORT_SHIPMENTS_REQUEST,
  viewRecordsOrSelectedRecords,
  extractId,
  selectedFulfillmentIds,
  searchTerm,
  filters,
  isOnAdvancedSearch,
});

export const CUSTOM_EXPORT_BATCH_SHIPMENTS_REQUEST = 'CUSTOM_EXPORT_BATCH_SHIPMENTS_REQUEST';
export const customExportBatchShipmentsRequest = (viewRecordsOrSelectedRecords, extractId, selectedShipmentIds, fulfillmentPlanSetId) => ({
  type: CUSTOM_EXPORT_BATCH_SHIPMENTS_REQUEST,
  viewRecordsOrSelectedRecords,
  extractId,
  selectedShipmentIds,
  fulfillmentPlanSetId,
});
